<!--  -->
<template>
  <div>
    <div class="head">
      <div class="head-layout">
        <img src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202103/338d8c90612041e4b6059d71dd8504a8.jpg"  />
        <span style="color:#fff;font-size:26px;margin-left:10px">{{name}}</span>
      </div>
    </div>
    <div class="layout">
      <div class="" style="min-height: 100px">
        <div class="">
          <!-- <Breadcrumb>
            <BreadcrumbItem>首页</BreadcrumbItem>
            <BreadcrumbItem>管理</BreadcrumbItem>
            <BreadcrumbItem>证件申请</BreadcrumbItem>
          </Breadcrumb> -->
          <div class="header-tool-title">证件导入</div>
        </div>
      </div>
      <div class="layout-button">
        <div class="card">
          <span>展商证</span>
          <div class="button" @click="goExport(1)">点击进入</div>
        </div>
        <div class="card">
          <span>特邀嘉宾</span>
          <div class="button" @click="goExport(2)">点击进入</div>
        </div>
        <div class="card">
          <span>海外/港澳台认证</span>
          <div class="button" @click="goExport(3)">点击进入</div>
        </div>
      </div>
      <div class="layout-button" style="justify-content: center;">
        <div class="card">
          <span>VIP</span>
          <div class="button" @click="goExport(4)">点击进入</div>
        </div>
      </div>
    </div>
    <iModal title="提示" width="600px" v-model="show" class-name="vertical-center-modal" :mask-closable="false" @on-cancel="show=false">
      <div>
        尊敬的展商您好：
        展商证认证已截止，如您的朋友需要参会请进行观众预登记，谢谢！
        期待与您4月7号上海见！
        如需进行观众预登记，请登录CMEF官网（cmef.com.cn）或公众微信号
      </div>

    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data () {
    return {
      //exhibitionId:"a1663ee9-8881-4ce3-9489-a53511601b8f",
      name: "",
      show: false,
    };
  },
  created () {
    this.init();
  },
  computed: {
    exhibitionId () {
      return this.$route.query.exhibitionId;
    },
  },
  methods: {
    ...mapActions({
      getExhibitionByIdNew: "exhibitionModule/getExhibitionByIdNew",
    }),
    async init () {
      let data = await this.getExhibitionByIdNew(this.exhibitionId);
      if (data.name) {
        this.name = data.name;
      }
    },
    goExport (index) {
      let date = "2022-03-30 23:59";
      let now = new Date().getTime();

      if (moment(now).format("YYYY-MM-DD HH:mm") > date) {
        this.show = true;
        return;
      }
      if (index == 1) {
        this.$router.push(
          "/exhibition/export?exhibitionId=" + this.exhibitionId + "&BadgeId=1"
        );
      }
      if (index == 2) {
        this.$router.push(
          "/exhibition/export?exhibitionId=" + this.exhibitionId + "&BadgeId=2"
        );
      }
      if (index == 3) {
        this.$router.push(
          "/exhibition/export?exhibitionId=" + this.exhibitionId + "&BadgeId=3"
        );
      }
      if (index == 4) {
        this.$router.push(
          "/exhibition/export?exhibitionId=" + this.exhibitionId + "&BadgeId=4"
        );
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.head {
  height: 100px;
  background: #333;
  &-layout {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 100px;
    img {
      width: 70px;
      height: 70px;
    }
  }
}
.layout {
  margin: 0 auto;
  max-width: 1200px;
  min-height: 500px;

  &-button {
    display: flex;
    justify-content: space-between;
    padding: 50px;
  }
  .card {
    width: 300px;
    height: 300px;
    text-align: center;
    background: #fff;
    padding: 70px 0px;
    span {
      font-size: 28px;
      font-weight: bold;
    }
    .button {
      width: 150px;
      height: 40px;
      background: red;
      display: flex;
      align-items: center;
      color: #fff;
      justify-content: center;
      font-size: 20px;
      margin: 50px auto;
      cursor: pointer;
    }
  }
}
</style>